// import ToolData from '@/utils/mockData/moreToolsData.js'
import newToolData from '@/utils/mockData/newToolsData'
import loginTip from '@/views/contents/calendar/component/logintip' //注册提示组件
import granaryDialog from '@/components/contents/granaryDialog.vue' //扫码积分提示
import { getToolSort } from '@/assets/js/toolCardCommon'
import {
  getCookie,
  isUserEdit,
  getBabyMonth,
  addCookie,
} from '@/assets/js/common.js'
import API from '@/utils/axiosApi/newToolApi.js'
import { TestUserAgent, goToMini } from '@/assets/js/common.js'
import openWxTag from '@/components/common/openWeappTag/index.vue'
import InfoIntellectApi from '@/utils/axiosApi/getUserInfoIntellect' //智能推算接口
export default {
  name: 'toolCard',
  data() {
    return {
      // toolsList: ToolData.toolsList, // 默认工具列表
      newToolsList: newToolData.toolsList, //新工具列表
      toolSort: [], //工具id
      // noLoginToolList: [], // 未登录或未定制默认工具列表
      // configToolList: [], // 手动配置的工具列表
      currentToolList: [], // 当前工具列表
      hostName: this.$http.hostName,
      checkLogin: false,
      dialogShow: false, //扫码提示弹窗
      isFlag: false, // 开关状态
      babyState: '',
      UserMessage: {},
      issystem: TestUserAgent().isios,
    }
  },
  components: { loginTip, granaryDialog, openWxTag },
  beforeRouteEnter(to, from, next) {
    next((vm) => {})
  },
  props: [
    'loginFlag',
    'editFlag',
    'UserInfo',
    'currentBabyInfo',
    'babyDays',
    'babyTipsList',
  ],
  mounted() {
    this.UserMessage = JSON.parse(localStorage.getItem('userInfo')) || {}
  },
  activated() {
    if (localStorage.getItem('babyInfo') && !getCookie('userInfoIntellect')) {
      this.getUserInfoIntellect()
    }

    this.getConfigList(this.loginFlag)
  },
  watch: {
    //loginFlag：登录状态
    loginFlag(newVal, oldVal) {
      this.getConfigList(!!newVal)
    },
    //currentBabyInfo：当前宝宝信息

    currentBabyInfo(newVal) {
      if (newVal && !this.isFlag) {
        this.getConfigList(true)
      }
    },
  },
  methods: {
    goToMini,
    // 根据当前状态设置默认工具
    getToolList() {
      // console.log(111,this.currentBabyInfo.tag_id);
      this.lookForEleme(getToolSort(this.currentBabyInfo.tag_id))
      this.isFlag = false
    },

    // 根据工具id数组筛选出符合的元素
    lookForEleme(list) {
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < this.newToolsList.length; j++) {
          if (list[i] == this.newToolsList[j].id) {
            this.currentToolList.push(this.newToolsList[j])
          }
        }
      }
    },
    // 查询是否配置过工具
    getConfigList(flag) {
      console.log(flag, '登录状态', isUserEdit(), '是否定制')
      // this.isFlag = true
      this.currentToolList = []
      // 已登录

      //接口参数
      let Toolparams = {
        crmId: this.UserMessage.crm_id || '', // crmID
        parityNum: this.currentBabyInfo.num || getCookie('babyNum'), // 胎次
        monthAge: this.currentBabyInfo.tag_id, // 月龄段
      }
      const babyInfo =
        (localStorage.getItem('babyInfo') &&
          JSON.parse(localStorage.getItem('babyInfo'))) ||
        null
      console.log(this.currentBabyInfo, '宝宝信息', babyInfo)
      console.log(Toolparams, '接口参数')
      // 查询用户自定义工具接口
      API.getUserTools({}, { ...Toolparams }, (res) => {
        console.log(33334444, res, res.data)
        if (res.code === 200) {
          // 赋值操作
          this.currentToolList = res.data
        }
      })

      // if(flag) {
      //   this.UserMessage = JSON.parse(localStorage.getItem("userInfo")) || {}
      //   // 未定制
      //   if(!isUserEdit()) {
      //     this.currentToolList = this.newToolsList.slice(0,9)
      //     this.isFlag = false
      //     this.getBabyState()
      //   } else { // 已定制
      //     // 根据接口查询是否配置过工具，如果没有判断是否定制宝宝
      //     this.$http.get('/userTools/getUserTool', { crmId: this.UserMessage.crm_id, parityNum: this.currentBabyInfo.num || getCookie("babyNum") }, (res) => {
      //       if (res.code == '200' && res.data != null) {  //配置过
      //         this.currentToolList = []
      //         this.lookForEleme(JSON.parse(res.data.toolsArray))
      //         this.isFlag = false
      //       } else {
      //         this.getToolList()
      //       }
      //       this.getBabyState()
      //     })
      //   }
      // } else {  // 未登录的工具列表
      //   this.currentToolList = this.newToolsList.slice(0, 9)
      //   this.isFlag = false
      //   this.getBabyState()
      // }
    },
    //首页智能推算用户信息
    getUserInfoIntellect() {
      const babyBirthDays = []
      const customizedStatus = []
      const babyInfo =
        (localStorage.getItem('babyInfo') &&
          JSON.parse(localStorage.getItem('babyInfo'))) ||
        null
      babyInfo.forEach((element) => {
        babyBirthDays.push(element.birth)
        customizedStatus.push(element.tag_id)
      })

      //接口参数
      let Toolparams = {
        userId: this.UserMessage.crm_id || '', // crmID
        babyBirthDays: babyBirthDays,
        userLevel: this.UserMessage.level,
        isCustomized: isUserEdit(),
        customizedStatus: customizedStatus,
      }
      console.log(Toolparams, '宝宝信息智能推算', babyInfo)

      localStorage.setItem('intellectInfo', 'intellectInfo is true')
      InfoIntellectApi.reportUserData({}, Toolparams, (res) => {
        if (res.code === 200) {
          console.warn('成功推算用户信息', res)
          addCookie({ name: 'userInfoIntellect', data: true })
          // 成功 跳转至申请成功页
        } else {
          console.error('接口报错', res.code)
        }
      })
    },
    // 跳转更多工具
    toMoreTool() {
      sensors.track('home_tool_click', {
        baby_state: this.babyState,
        tool_name: '更多',
        Baby_Month: getBabyMonth(),
        JumpMiniprogram:'',
      })
      if (
        this.currentBabyInfo &&
        JSON.stringify(this.currentBabyInfo) != '{}'
      ) {
        const month =
          this.currentBabyInfo.num == '1'
            ? this.babyDays.firsttime
            : this.babyDays.secondtime

        // 存储当前宝宝的成长天数 （防止页面多次跳转参数为undefined)
        const babyDays = {
          monthAge: this.babyTipsList.tagTime,
          month,
        }
        localStorage.setItem('babyGrowdate', JSON.stringify(babyDays))
        this.$router.push(
          '/moreTools?monthAge=' + this.babyTipsList.tagTime + '&month=' + month
        )
      } else {
        this.$router.push('/moreTools')
      }
    },
    // 判断是否登录 是否定制
    // 3生长曲线  8疫苗时间表 17产检提醒 21喂养记录  未定制去定制
    isLoginOrEdit(item, index) {
      this.toTool(item, index)
      // if(this.loginFlag) { // 已登录
      //   if(isUserEdit()) { // 已定制
      //     this.toTool(item,index)
      //   } else { // 未定制
      //     if(item.id == 3 || item.id == 17 || item.id == 8 || item.id == 21) {
      //       this.$emit('goEdit')
      //     } else {
      //       this.toTool(item,index)
      //     }
      //   }
      // } else { // 未登录
      //   if(item.id == 3 || item.id == 17 || item.id == 8 || item.id == 21 || item.id == 36) {
      //     this.$emit('goLogin')
      //   } else {
      //     this.toTool(item,index)
      //   }
      // }
    },
    // 跳转工具
    toTool(item, index) {
      sensors.track('home_tool_click', {
        baby_state: this.babyState,
        tool_name: item.name,
        toolmodule_location: index + 1,
        Baby_Month: getBabyMonth(),
        JumpMiniprogram:item.miniProgramTypeName,
      })

      console.log('跳转工具需要判断的参数', this.loginFlag, isUserEdit(), item)
      console.log(
        item.toolMonthAge.indexOf(this.currentBabyInfo.tag_id),
        123,
        item.toolMonthAge,
        this.currentBabyInfo.tag_id
      )
      if (item.isLogin === 0 && !this.loginFlag) {
        console.log('未登录去登录')
        this.$emit('goLogin')
        return
      }
      if (item.isCustomize === 0 && !isUserEdit()) {
        console.log('未定制去定制')
        this.$emit('goEdit')
        return
      }
      if (
        this.currentBabyInfo.tag_id &&
        item.toolMonthAge.indexOf(this.currentBabyInfo.tag_id) == -1
      ) {
        this.$toast('抱歉，当前月龄无法使用该工具哦')
        return
      }

      switch (item.urlType) {
        case 1: // 站内链接
          const month =
            this.currentBabyInfo.num == '1'
              ? this.babyDays.firsttime
              : this.babyDays.secondtime
          let { num, birth } = this.currentBabyInfo
          console.log(item.jumpUrl, '拼接参数前跳转的站内链接地址')
          if (item.jumpUrl.indexOf('?') == -1) {
            item.jumpUrl =
              item.jumpUrl +
              (item.jumpUrl.indexOf('from=') != -1 ? '' : '?from=home') +
              '&sourceFrom=home' +
              '&num=' +
              num +
              '&bir=' +
              birth +
              '&monthAge=' +
              this.babyTipsList.tagTime +
              '&month=' +
              month
          } else {
            item.jumpUrl =
              item.jumpUrl +
              (item.jumpUrl.indexOf('from=') != -1 ? '' : '&from=home') +
              '&sourceFrom=home' +
              '&num=' +
              num +
              '&bir=' +
              birth +
              '&monthAge=' +
              this.babyTipsList.tagTime +
              '&month=' +
              month
          }
          console.log(item.jumpUrl, '拼接参数后跳转的站内链接地址')
          this.$router.push({ path: item.jumpUrl })
          break
        case 2: // 站外链接
          location.href = item.jumpUrl
          // location.href = 'https://chengzhangxiangce.feihe.com/weixin.php?channel_id=4'
          break
        case 3: // 小程序链接
          console.log('跳转小程序链接')
          break
      }

      // let bg = document.getElementsByClassName('bgWrap')[0]
      // bg.classList.remove('bg-blur')
      // switch (item.id) {
      //   case 1: // 育儿宝典
      //   case 10: // 备孕宝典
      //   case 15: // 孕期宝典
      //     this.$router.push({ path: item.link + '?from=home' })
      //     break
      //   case 2: // 宝宝食谱
      //   case 9: // 能不能吃
      //   case 13: // 专家问答
      //   case 25: // 营养厨房
      //   case 26: // 宝宝辅食
      //   case 28: // 育儿问答
      //     this.$router.push({ path: item.link })
      //     break
      //   case 3: // 生长曲线 参数 num：当前宝宝胎次
      //     this.$router.push({ path: item.link + '?sourceFrom=home&num=' + this.currentBabyInfo.num })
      //     break
      //   case 4: // 儿歌故事
      //   case 11: // 助眠音乐
      //   case 16: // 胎教音乐
      //   case 22: // 哄睡儿歌
      //     this.$router.push({ path: item.link + '?from=song' })
      //     break
      //   case 5: // 宝宝相册
      //   case 14: // 云相册
      //   case 18: // 孕期相册
      //     location.href = 'https://chengzhangxiangce.feihe.com/weixin.php?channel_id=4'
      //     break
      //   case 6: // 扫码积分
      //     this.weiScanSHnader()
      //     break
      //   case 7: // 产品溯源
      //     location.href = 'http://wic.feihe.com/review/front/review/sweep?source=1'
      //     break
      //   case 8: // 疫苗时间表 参数 num：当前宝宝胎次  bir: 当前宝宝生日
      //     if (this.currentBabyInfo.tag_id > 2) {
      //       this.$router.push({ path: item.link + '?num=' + this.currentBabyInfo.num + '&bir=' + this.currentBabyInfo.birth })
      //     } else {
      //       this.$toast("需要先有宝宝才能使用哦~");
      //     }
      //     break
      //   case 12: // 备孕问诊
      //     // case  23: // 育儿问诊
      //     // case  24: // 家庭问诊
      //     // case  27: // 母婴问诊
      //     // case  29: // 孕期问诊
      //     if (this.UserMessage == null || this.UserMessage == "" || this.UserMessage.mobile == null || this.UserMessage.mobile == "" || this.UserMessage.mobile == "null") {
      //       this.checkLogin = true
      //     } else {
      //       this.$router.push({ path: "/lineDoctor?utm_campaign=XMH_H5_HOME_ICON" })
      //     }
      //     break
      //   case 17: // 产检提醒 参数 num：当前宝宝胎次  bir: 当前宝宝生日
      //     if (this.currentBabyInfo.tag_id == 1) {
      //       this.$toast('需要怀孕了才能用哦~')
      //     } else {
      //       this.$router.push({ path: item.link + '?num=' + this.currentBabyInfo.num + '&bir=' + this.currentBabyInfo.birth })
      //     }
      //     break
      //   case 21: // 喂养记录 未定制去定制 备孕和孕期点击提示toast文案 参数 num：当前宝宝胎次  monthAge：    month:
      //     if (this.currentBabyInfo.tag_id > 2) {
      //       const month = this.currentBabyInfo.num == '1' ? this.babyDays.firsttime : this.babyDays.secondtime;
      //       this.$router.push({ path: item.link + '?num=' + this.currentBabyInfo.num + '&monthAge=' + this.babyTipsList.tagTime + '&month=' + month })
      //     } else {
      //       this.$toast('需要先有宝宝才能使用哦~')
      //     }
      //     break
      //   case 30: // 星牧场
      //     location.href = 'https://2022xingmuchang.feihe.com/weixin.php?channel_id=29'
      //     break;
      //   case 32: // 奶粉百科
      //     this.$router.push({ path: "/powderedMilk" })
      //     break;

      //   case 31:
      //     location.replace(location.origin + '/member/splitBlindBox?result=tool')
      //     break
      //   case 33: //营养测评
      //     location.href = 'https://www.wjx.cn/vm/rZ1ECPI.aspx'
      //     break;
      //   case 34: //辅食测评
      //     location.href = 'https://www.wenjuan.ltd/s/muQn6jT/#'
      //     break;
      //   case  36: // 奶粉百科
      //     this.$router.push({ path: "/trialProducts" })
      //     break;
      //   case 35: // 喂养之道
      //     this.$router.push({ path: "/babyFeeding" })
      //     break;
      // }
    },
    //微信扫码
    weiScanSHnader() {
      // if (!localStorage.getItem("isWxScan")) {
      //   this.dialogShow = true
      //   localStorage.setItem("isWxScan", true)
      // } else {
      this.dialogShow = false
      localStorage.setItem('sweep_source', '星妈会首页')
      // location.href = "/sweep"
      location.href = location.origin + '/member/sweep?type=home'
      // this.$router.push({ path: "/sweep" })
      // }
    },
    // 取消扫码提示弹窗
    cancelDialog: function (flag) {
      this.dialogShow = flag
    },
    // 健康问诊弹窗
    confirmWay() {
      this.checkLogin = false
      this.$emit('goLogin')
    },
    cancleWay() {
      this.checkLogin = false
    },
    // 判断宝宝当前状态
    getBabyState() {
      // 判断是否有宝宝
      if (this.currentBabyInfo.tag_id) {
        // 判断当前是否是有宝
        if (this.currentBabyInfo.tag_id > 2) {
          this.babyState = this.currentBabyInfo.sex == 'F' ? '小公主' : '小王子'
        } else {
          this.babyState = this.currentBabyInfo.tag_id == '1' ? '备孕' : '怀孕'
        }
      } else {
        this.babyState = '无'
      }
    },
  },
}
